query Instance {
  instance {
    domainProvider
    liveEnabled
    videoProvider
    paymentProviders
  }
}
